export default __webpack_public_path__ + "static/media/appsmith-datasource.125351e7.svg";